/*
  returns the number of days in a given month.
  Note: If no year is provided, it will return 29 for February.
*/

export function getDaysInMonth({ month, year }) {
  let daysInMonth = 31;
  if (month === 4 || month === 6 || month === 9 || month === 11) {
    daysInMonth = 30;
  } else if (month === 2) {
    // Oh pesky February!
    daysInMonth = 28;

    if (!year) {
      // If no year provided, allow Feb 29
      daysInMonth = 29;
    } else if (year % 4 === 0 && year % 100 !== 0) {
      // Check if it's a leap year.
      daysInMonth = 29;
    }
  }

  return daysInMonth;
}
